import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import CheckMark from '../../../assets/images/grey-check-icon.svg';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import { YOUNG_PROFESSIONALS_PLAN } from '../../utils/subscriptionCardOptions';
import Offers from './Offers';

interface SingleOffersProps {
  description?: string;
  offer: OfferOption;
  selectedOffer: SelectedOffer;
}

const BENEFITS = [
  'Read in-depth stories you won’t find anywhere else',
  'Subscribe to our suite of newsletters',
  'Attend monthly live events',
  'Read on the go with The Information app',
];

const SingleOffer = ({ description, offer, selectedOffer }: SingleOffersProps) => {
  const isYPPlan = offer.code.includes(YOUNG_PROFESSIONALS_PLAN);

  return (
    <div>
      <div
        className={clsx('tw-h-min-auto', {
          'sm:tw-min-h-[132px]': isYPPlan,
          'sm:tw-min-h-[188px]': !isYPPlan,
        })}
      >
        <h2 className="tw-mb-20 tw-mt-24 tw-font-serif tw-font-normal">
          {ReactHtmlParser(offer.header)}
        </h2>
        <p className="tw-font-serif tw-text-body-lg tw-text-gray-600">
          {description || ReactHtmlParser(offer.subHeader)}
        </p>
      </div>
      <div className="tw-mb-20 tw-mt-24 tw-flex tw-items-center">
        <div className="tw-font-sans tw-text-body-sm tw-font-bold tw-uppercase tw-text-primary-red">
          Special Offer
        </div>
        <div className="tw-ml-12 tw-h-2 tw-flex-1 tw-bg-primary-red"></div>
      </div>
      <Offers offers={[offer]} selectedOfferCode={selectedOffer.code} />
      <div className="tw-mt-32">
        {BENEFITS.map((benefit, index) => (
          <div
            key={index}
            className="tw-mb-8 tw-flex tw-items-center tw-font-sans tw-text-grayscale-80"
          >
            <img src={CheckMark} className="tw-mr-8" />
            <div className="tw-w-full tw-border-0 tw-border-b tw-border-solid tw-border-neutral-200 tw-py-4">
              {benefit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleOffer;
